import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultOptions: ToastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  className: "",
  bodyClassName: "text-white text-center text-base p-0 font-[poppins]",
  closeButton: false,
};

export const toastService = {
  success: (message: string, autoClose = 3000) => {
    toast.success(message, {
      ...defaultOptions,
      autoClose,
      className:
        "bg-green-600 text-white text-center rounded-lg flex items-center max-h-[6rem!important] min-h-[3rem!important] shadow-md p-0 max-h-[5rem!important] min-h-[3rem!important]",
    });
  },
  error: (message: string, autoClose = 3000) => {
    toast.error(message, {
      ...defaultOptions,
      autoClose,
      className:
        "bg-red-600 text-white text-center rounded-lg flex items-center max-h-[6rem!important] min-h-[3rem!important] shadow-md p-0 max-h-[5rem!important] min-h-[3rem!important]",
    });
  },
  info: (message: string, autoClose = 3000) => {
    toast.info(message, {
      ...defaultOptions,
      autoClose,
      className:
        "bg-blue-600 text-white text-center rounded-lg flex items-center max-h-[6rem!important] min-h-[3rem!important] shadow-md p-0 max-h-[5rem!important] min-h-[3rem!important]",
    });
  },
  warn: (message: string, autoClose = 3000) => {
    toast.warn(message, {
      ...defaultOptions,
      autoClose,
      className:
        "bg-yellow-500 text-black rounded-lg flex items-center max-h-[6rem!important] min-h-[3rem!important] shadow-md p-0 max-h-[5rem!important] min-h-[3rem!important]",
    });
  },
};
